import React, { useEffect, useRef, useState } from 'react';
import '../styles/MissionVisionValues.css';
import { FaBullseye, FaUsers, FaBook } from 'react-icons/fa';
import OpenQuran from '../images/openquran.jpg';
import PathImage from '../images/path.jpg';
import UnityImage from '../images/unity.jpg';
import DecorationImage from '../images/lantern.png';

const MissionVisionValues = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const data = [
    {
      icon: <FaBook />,
      title: "Mission",
      text: "To revitalize Islamic education by integrating Islamic values with modern pedagogical practices, fostering the development of morally grounded leaders prepared to excel in a diverse and dynamic world.",
      image: OpenQuran,
    },
    {
      icon: <FaBullseye />,
      title: "Vision",
      text: "To be a global leader in Islamic education, inspiring learners to reach their full potential and contribute positively to society guided by Islamic principles.",
      image: PathImage,
    },
    {
      icon: <FaUsers />,
      title: "Values",
      text: "Our values are Tawheed, integrity, compassion, and excellence, guiding our community to act ethically, care deeply, and strive relentlessly to succeed.",
      image: UnityImage,
    },
  ];

  // Observe if the section is in the viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className={`mv-section ${isVisible ? "visible" : ""}`} ref={sectionRef}>
    {isVisible && <img src={DecorationImage} alt="Decoration" className="mv-decoration" />}
      <div className="mv-container">
        <h2 className="mv-heading">Mission, Vision & Values</h2>
        <div className="mv-cards">
          {data.map((item, index) => (
            <div
              key={index}
              className="mv-card"
              style={{ '--card-image': `url(${item.image})` }}
            >
              <div className="mv-card-content">
                <div className="mv-icon">{item.icon}</div>
                <h3 className="mv-title">{item.title}</h3>
                <p className="mv-text">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionVisionValues;
